<qrcode class="hidden" #parent_qrcode
  [qrdata]="qrdata"
  [allowEmptyString]="true"
  [ariaLabel]="'QR Code image with the badge image'" [cssClass]="'center'" [colorDark]="'#000000ff'"
  [colorLight]="'#ffffffff'" [elementType]="'canvas'" [errorCorrectionLevel]="'M'" [elementType]="'img'" [margin]="0"
  [scale]="1" [title]="'QR Code image with the badge image'" [width]="300"
  [imageSrc]="logo"
  [imageHeight]="imageHeight"
  [imageWidth]="imageWidth">
</qrcode>
<div class="hidden">
  <canvas *ngIf="edizione" width="{{edizione.bw}}" height="{{edizione.bh}}" id="hidden_canvas"></canvas>
</div>
<div (click)="getImage($event)" #div_canvas_wrapper (window:resize)="onResize(div_canvas_wrapper.getBoundingClientRect())" class="cursor-zoom-out h-64"
  style="border: none">
  <div class="m-auto w-auto text-center {{h_badge}} inline-block">
    <img [src]="imageB64Path" class="badge m-auto cursor-zoom-in">
  </div>
</div>
<!-- MODAL -->
<!-- Modal container -->
<div *ngIf="isModalBadgeOpen"
  class="fixed top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
  <div
    class="relative p w-full max-w-xl md:max-w-2xl bg-white rounded-lg shadow dark:bg-gray-700 max-h-[90vh] overflow-y-auto mx-4 md:mx-0">

    <!-- Modal header -->
    <div class="sticky top-0 flex items-center justify-between p-4 border-b rounded-t bg-white dark:border-gray-600">
      <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
        Badge
      </h3>
      <button (click)="closeModal()" class="cursor-pointer"
        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white">
        <!-- Close SVG -->
        <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
        </svg>
        <span class="sr-only">Close modal</span>
      </button>
    </div>
    <!-- Modal body -->
    <div class="text-center w-full p-8">
      <img [src]="imageB64Path" class="preview">
    </div>
    <div class="text-center text-sm color-warning">{{print_error}}</div>
  </div>
</div>

